import {Box, HStack, StackProps, Text, VStack} from "@chakra-ui/react";
import React, {JSX, useEffect, useState} from "react";
import {
    EventIcon,
    ExitIcon,
    HomeComponent,
    MediaIcon, PersonIcon,
    ProducerIcon,
    ProductIcon
} from "../../components/atoms/SvgImage";
import {Outlet, useLocation, useNavigate} from "react-router-dom";
import {useAppDispatch, useAppSelector} from "../../hooks/use-store";
import {changeSection, changeSubSection} from "../../store/reducers/dashboard-reducer";
import {AnimatePresence, motion} from "framer-motion";
import {FaCashRegister} from "react-icons/all";
import {StarIcon} from "@chakra-ui/icons";

interface NavigationMenuItem {
    icon?: JSX.Element;
    title?: string;
    stackProps?: StackProps;
    subMenu?: NavigationMenuItem[];
    index?: number;
    path?: string;
}

const mainNavigationItems = ({userType}: { userType: String }) => [
    // userType !== "admin" ? {
    //     icon: <HomeComponent/>,
    //     title: "Home",
    //     path: "/"
    // } : null,
    {
        icon: <FaCashRegister/>,
        title: "Ordini",
        path: "/orders"
    },
    {
        icon: <ProductIcon/>,
        title: "Prodotti",
        path: "/products",
        subMenu: [
            {title: userType === "admin" ? "Prodotti" : "I miei prodotti", path: "/products"},
            {title: userType === "admin" ? "Lotti" : "I miei lotti", path: "/products/lots"},
            {title: "Categorie", path: "/products/category"},
            {title: "Chatbot", path: "/products/chatbot"},
            {title: "Crea prodotto", path: "/products/create"},
        ]
    },
    {
        icon: <EventIcon/>,
        title: "Eventi",
        path: "/events",
        subMenu: [
            {title: "I miei eventi", path: "/events"},
            {title: "Crea nuovo", path: "/events/add"},
        ]
    },
    userType === "admin" ? {
        icon: <StarIcon/>,
        title: "In evidenza",
        path: "/featured",
        // subMenu: [
        //     {title: "I miei eventi", path: "/events"},
        //     {title: "Crea nuovo", path: "/events/add"},
        // ]
    }: null,
    userType === "admin" ? {
        icon: <MediaIcon/>,
        title: "Media",
        path: "/media",
        // subMenu: [
        //     {title: "I miei media", path: "/media"},
        //     {title: "Crea nuovo", path: "/media/add"},
        // ]
    } : null,
    userType === "admin" ? { //TODO
        icon: <ProducerIcon/>,
        title: "Produttori",
        path: "/producers",
    } : null,

    userType === "admin" ? {
        icon: <PersonIcon/>,
        title: "Utenti",
        path: "/users",
    } : null
];

function getMenuIndex(path: string,) {
    // if (path === "/") return userType === "admin" ? 1 : 0;
    if (path === "/") return 0;
    const section = path.split('/')[1];

    console.log(section);

    switch (section) {
        case "orders":
            return 0;
        case "products":
            return 1;
        case "events":
            return 2;
        case "featured":
            return 3;
        case "media":
            return 4;
        case "producers":
            return 5;
        case "users":
            return 6;
    }
    return 0;
}

function getMenuSubsection(path: string) {
    const section = path.split('/')[1];
    const subSection = path.split('/')[2];

    if(subSection?.length === 0) return 0

    switch (section) {
        case "products":
            switch(subSection) {
                case "lots":
                    return 1;
                case "category":
                    return 2;
                case "chatbot":
                    return 3;
                case "create":
                    return 4;
            }
            return 0;
        case "events":
            if(subSection === "add") return 1;
            return 0;
        // case "media":
        //     return 0;
        // case "producers":
        //     return 0;
        // case "users":
        //     return 0;
        default:
            return 0;
    }
}

export default function DashboardPage() {
    const [subMenu, setSubMenu] = useState<NavigationMenuItem[]>([])
    const dispatch = useAppDispatch();
    const navigate = useNavigate();

    const [isLogged, setIsLogged] = useState(false);
    const userType = localStorage.getItem("userType");

    const location = useLocation();

    useEffect(() => {
        const token = localStorage.getItem("tokenNew"); // TODO: verify token validation
        if (!token) {
            navigate("/landing");
        } else {
            setIsLogged(true);
        }
    }, []);

    useEffect(() => {
        const index = getMenuIndex(location.pathname);
        console.log({index, menu: getMenuIndex(location.pathname)});
        changeSection(getMenuIndex(location.pathname));
        dispatch(changeSection(index));
        setSubMenu(mainNavigationItems({userType: userType || "seller"})[index]?.subMenu || []);
        dispatch(changeSubSection(getMenuSubsection(location.pathname)));
    }, [location, userType]);

    // if (isLogged)
    return <HStack w={"100vw"} h={"100vh"} spacing={0} overflow={"hidden"} backgroundColor={"surface.light"}>
        <VStack w={"100px"} minW={"100px"} h={"100%"} backgroundColor={"surfaceContainer.light"}>
            {mainNavigationItems({userType: userType || "seller"}).map((item, index) => {
                if (!item) return null;
                const {title, icon, path} = item || {};
                return <NavigationIconButton key={`dashboard_navigation_btn_${index}`} title={title} index={index}
                                             icon={icon} stackProps={{
                    onClick: () => {
                        navigate({pathname: path});
                    }
                }}/>
            })}
            <NavigationIconButton title={"Esci"} icon={<ExitIcon/>} stackProps={{
                marginTop: "auto",
                mb: "16px",
                onClick: () => {
                    localStorage.removeItem("token");
                    navigate({pathname: "/landing"});
                }
            }}/>
        </VStack>–

        <AnimatePresence>
            {subMenu.length > 0 && <motion.div
                initial={{width: 0}}
                exit={{width: 0}}
                animate={{width: '200px'}}
                style={{height: "100%", overflow: "hidden"}}
                transition={{duration: 0.5}}>
                <NavigationSubSection subsection={subMenu}/>
            </motion.div>}
        </AnimatePresence>

        {/*{subMenu.length > 0 && <NavigationSubSection subsection={subMenu}/>}*/}
        {/*            <Box h={"100%"}>
                <Slide in={subMenu.length > 0} direction={"left"}>
                    <NavigationSubSection subsection={subMenu}/>
                </Slide>
            </Box>*/}

        <Box h={"100%"} flex={1} overflow={"auto"}>
            <Outlet/>
        </Box>
    </HStack>
    // else return <SplashPage/>
}

const NavigationSubSection = ({subsection}: { subsection: NavigationMenuItem[] }) => {
    const {currentSubSection} = useAppSelector(state => state.dashboard);
    const dispatch = useAppDispatch();
    const navigate = useNavigate();

    return <VStack w={"200px"} minW={"200px"} h={"100%"}
                   backgroundColor={"surfaceContainer.light"}
                   pt={"24px"} px={"8px"} borderLeftWidth={"2px"} borderLeftColor={"#B4CCBD33"}
                   borderRightRadius={"16px"}>
        {subsection.map((value, index) => {
            const {title, path} = value || {};

            return <HStack
                borderRadius={"16px"}
                key={`submenu_item_${index}`}
                cursor={"pointer"}
                _hover={{backgroundColor: currentSubSection === index ? "tertiary.200" : "secondary.200"}}
                backgroundColor={currentSubSection === index ? "tertiary.200" : "transparent"}
                w={"100%"} h={"48px"}
                onClick={() => {
                    dispatch(changeSubSection(index));
                    navigate({pathname: path});
                }}
                justifyItems={"flex-start"}>
                <Text ms={"18px"} my={"8px"} textAlign={"start"}>{title}</Text>
            </HStack>
        })}
    </VStack>
}

const NavigationIconButton = ({icon, title, stackProps, index}: NavigationMenuItem) => {
    const {currentSection} = useAppSelector(state => state.dashboard);

    return <VStack
        w={"64px"}
        h={"64px"}
        mt={"24px"}
        justifyContent={"center"}
        alignItems={"center"}
        borderRadius={"16px"}
        cursor={"pointer"}
        _hover={{
            backgroundColor: currentSection === index ? "tertiary.200" : "secondary.200"
        }}
        backgroundColor={currentSection === index ? "tertiary.200" : "transparent"}
        {...stackProps}>
        {icon}
        <Text fontSize={"12px"} color={"black"}>{title}</Text>
    </VStack>
};
